import Client from './Clients/ScrapingToolsClient'

const resource = '/outputs/popularity_data/'
const chartResource='/outputs/popularity_data/chart/'
const headerResource='/outputs/dashboard/header/'

export default {
    get(){
        return Client.get(resource);
    },
    getChart(payload,exportChart){
        if(exportChart){
            return Client.post(chartResource,payload,{responseType:'blob'});
        }
        else{
            return Client.post(chartResource,payload);
        }
    },
    getDashboardHeaders(){
        return Client.get(headerResource);
    }
}